$(function () {
    "use strict";

    // Spinner
    var spinner = function () {
        setTimeout(function () {
            if ($('#spinner').length > 0) {
                $('#spinner').removeClass('show');
            }
        }, 1);
    };
    spinner();

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    // Initiate the wowjs
    new WOW().init();


    // Sticky Navbar
    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.sticky-top').addClass('shadow-sm').css('top', '0px');
        } else {
            $('.sticky-top').removeClass('shadow-sm').css('top', '-100px');
        }
    });


    // Back to top button
    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.back-to-top').fadeIn('slow');
        } else {
            $('.back-to-top').fadeOut('slow');
        }
    });
    $('.back-to-top').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 1500, 'easeInOutExpo');
        return false;
    });


    // Facts counter
    $('[data-toggle="counter-up"]').counterUp({
        delay: 10,
        time: 2000
    });


    // carrier carousel
    $(".carrier-carousel").owlCarousel({
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        center: true,
        dots: false,
        loop: true,
        nav: true,
        navText: [
            '<i class="bi bi-arrow-left"></i>',
            '<i class="bi bi-arrow-right"></i>'
        ],
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            }
        }
    });

    // regular carousel
    $(".regular-carousel").owlCarousel({
        autoplay: true,
        smartSpeed: 1000,
        center: true,
        dots: false,
        loop: true,
        nav: true,
        navText: [
            '<i class="bi bi-arrow-left"></i>',
            '<i class="bi bi-arrow-right"></i>'
        ],
        responsive: {
            0: {
                items: 1
            }
        }
    });


    // Portfolio isotope and filter
    var portfolioIsotope = $('.portfolio-container').isotope({
        itemSelector: '.portfolio-item',
        layoutMode: 'fitRows'
    });
    $('#portfolio-flters li').on('click', function () {
        $("#portfolio-flters li").removeClass('active');
        $(this).addClass('active');

        portfolioIsotope.isotope({ filter: $(this).data('filter') });
    });

    $('#editAccountBtn').click(function () {
        console.log(this);

        if ($(this).hasClass('formActive')) {
            $('#accountDetailsForm').submit();
            $(this).removeClass('formActive');
            $('.adi').attr('disabled', 'disabled');
            $(this).text('Edit Account Information');
        } else {
            $(this).addClass('formActive');
            $('.adi').removeAttr('disabled');
            $(this).text('Save Changes');
        }
    });

    // resource card filter
    $('.resource-card-widget').each(function (e) {
        var resourceCardFilter = $(this).find('.resource-card-filter');
        var resourceCardFilterButtons = $(resourceCardFilter).find('li');
        var resourceCards = $(this).find('.resource-card');

        $(resourceCardFilterButtons).click(function (e) {
            // change active
            $(resourceCardFilterButtons).removeClass('active');
            $(this).addClass('active');

            // filter cards
            if ($(this).data('filter') === "*") {
                $(resourceCards).each(function (e) {
                    $(this).css('display', 'block');
                });
            } else {
                var clickedFilter = $(this).data('filter');
                $(resourceCards).each(function (e) {
                    if ($(this).data('filter') === clickedFilter) {
                        $(this).css('display', 'block');
                    } else {
                        $(this).css('display', 'none');
                    }
                });
            }

        });

        $(resourceCards).hover(function (e) {
            $(this).find('.portfolio-btn').css('opacity', '100%');
        }, function (e) {
            $(this).find('.portfolio-btn').css('opacity', '0%');
        });
    });
});

